export const OPEN_MEMBER_STAMP_DIALOG_EVENT = "open-member-stamp-dialog"
export const OPEN_SMS_LAYER_EVENT = "open-sms-layer"
export const CLOSE_SMS_LAYERS_EVENT = "close-sms-layers"
export const OPEN_PURCHASE_LAYER_EVENT = "open-purchase-layer"
export const OPEN_PREPAYMENT_EVENT = "open-prepayment-window"
export const PREPAYMENT_CHANGED_EVENT = "prepayment-changed"
export const RESERVATION_CHANGED_EVENT = "reservation-changed"
export const CID_INCOMING_CALL_EVENT = "cid-incoming-call"
export const CID_INCOMING_MESSAGE_EVENT = "cid-incoming-message"
export const CID_CALL_STATUS_CHANGED_EVENT = "cid-call-status-changed"

export type MessageInitialMenu = "sms-send" | "kakao-alimtalk"

export interface PrepaymentOpenEventDetail {
  patientUuid: string
}

export interface MessagePatientData {
  patientId?: number | null
  patientUuid?: string | null
  patientName?: string | null
  patientPhone?: string | null
  messageInitialMenu?: MessageInitialMenu | null
  smsDirectSendOnly?: boolean | null
  smsInitialView?: "template" | "preview" | null
  smsTemplateTitle?: string | null
  smsTemplateContent?: string | null
}

export interface ReservationChangedEventDetail {
  patientUuid: string
}

export interface CidIncomingCallEventDetail {
  cidHistoryUuid: string
  provider: "kt" | "lguplus"
  remoteNumber: string
  eventDt: string | null
  patientUuid: string | null
  patientId: number | null
  patientName: string | null
  patientGender: string | null
  patientAge: number | null
  nextReservationDate: string | null
  isNewReservation?: boolean
  reservationName?: string | null
  callerName?: string | null
}

export interface CidIncomingMessageEventDetail extends CidIncomingCallEventDetail {
  messageContent: string
}

export type CidCallStatus = "ringing" | "answered" | "ended" | "missed" | "failed"

export interface CidCallStatusChangedEventDetail {
  cidHistoryUuid: string
  status: CidCallStatus
}

export const dispatchReservationChanged = (patientUuid?: string | null) => {
  if (!patientUuid || typeof window === "undefined") return

  window.dispatchEvent(new CustomEvent<ReservationChangedEventDetail>(RESERVATION_CHANGED_EVENT, { detail: { patientUuid } }))
}
